var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6996 11.4653C19.8242 11.337 19.9231 11.1845 19.9906 11.0166C20.058 10.8488 20.0928 10.6688 20.0928 10.4871C20.0928 10.3053 20.058 10.1254 19.9906 9.95751C19.9231 9.78965 19.8242 9.63718 19.6996 9.50883L10.8015 0.323257C10.7024 0.220786 10.5848 0.139489 10.4552 0.0840202C10.3257 0.0285515 10.1868 -3.03718e-07 10.0466 -3.08018e-07C9.90635 -3.12318e-07 9.76749 0.0285514 9.63796 0.0840202C9.50842 0.139489 9.39076 0.220786 9.2917 0.323257L0.393623 9.50883C-0.131053 10.0505 -0.131053 10.9237 0.393623 11.4653C0.918298 12.0069 1.76421 12.0069 2.28888 11.4653L10.0519 3.46249L17.815 11.4764C18.329 12.0069 19.1856 12.007 19.6996 11.4653Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowup);
export default __webpack_public_path__ + "static/media/arrowup.573061569e866ce86e8f4697db84ee07.svg";
export { ForwardRef as ReactComponent };